// src/components/Alertmessage.js
import React, { useEffect } from 'react';
import './Alertmessage.css'; // Ensure the CSS file is named correctly

const Alertmessage = ({
  message,
  onClose,
  type = "alert",
  onConfirm,
  onCancel,
  inputValue,
  onInputChange,
  inputPlaceholder,
}) => {
  useEffect(() => {
    // Add style to body to prevent scrolling
    document.body.style.overflow = 'hidden';

    // Cleanup function to restore scrolling when the component is unmounted
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  if (!message) return null; // Do not render if there is no message

  return (
    <div className="alert-modal-overlay">
      <div className="alert-modal-content">
        <p>{message}</p>

        {type === "prompt" && (
          <input
            type="text"
            className="alert-modal-input"
            value={inputValue || ""}
            onChange={onInputChange}
            placeholder={inputPlaceholder}
          />
        )}

        {type === "alert" && (
          <button className="alert-modal-close" onClick={onClose}>
            Close
          </button>
        )}

        {type === "confirm" && (
          <div className="alert-modal-buttons">
            <button className="alert-modal-confirm" onClick={onConfirm}>
              Yes
            </button>
            <button className="alert-modal-close" onClick={onCancel}>
              No
            </button>
          </div>
        )}

        {type === "prompt" && (
          <div className="alert-modal-buttons">
            <button className="alert-modal-confirm" onClick={onConfirm}>
              Submit
            </button>
            <button className="alert-modal-close" onClick={onCancel}>
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alertmessage;
